import { Size } from "./size";

export function Spacer({ size }: { size: Size }) {
  return <div style={{ marginBottom: size }} />;
}
